<template>
    <vx-table class="xl:grid-cols-[2fr_1fr_1fr_30px_100px_100px_auto] mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader data-test="header">
            <div class="lg:pl-6">Name</div>
            <div>External ID</div>
            <div>Team</div>
            <div>OU</div>
            <div>Status</div>
            <div>Billable</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
